import { css } from 'styled-components';

const styles = {
  listItem: css`
    a {
      opacity: 1;
    }
    a:hover {
      opacity: 0.7
    }
  `,
};

export default styles;
